<template>
  <div class="chain-page">
    <ChainWrapper />  
  </div>
</template>

<script>
import ChainWrapper from '@/wrappers/ChainWrapper.vue';

export default {
  name: 'ChainPage',
  components: {
    ChainWrapper,
  },
  data() {
    return {
        // Add your component data here
    };
  },
  methods: {
      // Add your methods here
  },
  computed: {
      // Add your computed properties here
  },
  mounted() {
      // Lifecycle hook for when the component is mounted
  }
};
</script>

<style scoped>
.chain-view {
  /* Add your styles here */
}
</style>